import { createContext } from "react";

// Create context for RecipeCard component (Provider/Consumer) and Favorites page (Consumer)
const FavoritesContext = createContext([]);

export default FavoritesContext;